<template>
	
	<!-- Main Sidebar -->
	<component :is="navbarFixed ? 'a-affix' : 'div'" :offset-top="top">

		<!-- Layout Header -->
		<a-layout-header>
			<a-row type="flex">

				<!-- Header Breadcrumbs & Title Column -->
				<a-col :span="4" :md="1" class="sidebar-toggler-col">

					<!-- / Header Page Title -->
					<a-button type="link" class="sidebar-toggler" @click="$emit('minimizeSidebar') , resizeEventHandler()">
						<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"/></svg>
					</a-button>

				</a-col>
				<!-- / Header Breadcrumbs & Title Column -->
	
				<!-- Header Breadcrumbs & Title Column -->
				<a-col :span="20" :md="6">

				<!-- Header Breadcrumbs -->
				<a-breadcrumb>
					<template v-for="(item, key) in $route.meta.breadcrumbs">
						<a-breadcrumb-item v-if="key == $route.meta.breadcrumbs.length - 1" :key="key">{{ item }}</a-breadcrumb-item>
						<a-breadcrumb-item v-else :key="key"><router-link to="/">{{ item }}</router-link></a-breadcrumb-item>
					</template>
				</a-breadcrumb>
				<!-- / Header Breadcrumbs -->

				<!-- Header Page Title -->
				<div class="ant-page-header-heading">
					<span class="ant-page-header-heading-title">{{ this.$route.meta.title || this.$route.name }}</span>
				</div>
				<!-- / Header Page Title -->

				</a-col>
				<!-- / Header Breadcrumbs & Title Column -->

				<!-- Header Control Column -->
				<a-col :span="24" :md="17" class="header-control">

					<!-- Header Control Buttons -->
					<a-button type="link" class="sidebar-toggler" @click="$emit('toggleSidebar', ! sidebarCollapsed) , resizeEventHandler()">
						<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"/></svg>
					</a-button>
					<!-- Notification Bell (admin only) -->
					
					<a-button type="link" class="profile-icon" @click="openProfile">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<span>Profile</span>
					</a-button>
					<a-button type="link" class="btn-logout" @click="logout">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M16 17L21 12L16 7" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M21 12H9" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M12 19C12 20.1046 11.1046 21 10 21H6C4.89543 21 4 20.1046 4 19V5C4 3.89543 4.89543 3 6 3H10C11.1046 3 12 3.89543 12 5" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<span>Logout</span>
					</a-button>
					<NotificationDropdown v-if="isAdmin" />
					<!-- / Header Control Buttons -->

				</a-col>
				<!-- / Header Control Column -->

			</a-row>
		</a-layout-header>
		<!--  /Layout Header -->

	</component>
	<!-- / Main Sidebar -->

</template>

<script>
import VueCookies from 'vue-cookies';
import NotificationDropdown from '@/components/Notifications/NotificationDropdown.vue';

	export default ({
		components: {
			NotificationDropdown
		},
		props: {
			// Header fixed status.
			navbarFixed: {
				type: Boolean,
				default: false,
			},

			// Sidebar collapsed status.
			sidebarCollapsed: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				// Fixed header/sidebar-footer ( Affix component ) top offset.
				top: 0,
			}
		},
		computed: {
			// Check if current user is admin
			isAdmin() {
				return localStorage.getItem('userType') === 'admin';
			}
		},
		methods: {
			resizeEventHandler(){
				this.top = this.top ? 0 : -0.01 ;
				// To refresh the header if the window size changes.
				// Reason for the negative value is that it doesn't activate the affix unless
				// scroller is anywhere but the top of the page.
			},
			openProfile(){
				this.$router.push({ name: 'Profile' });
			},
			logout(){
				try {
					// Drop the realtime socket so it stops carrying this user's
					// identity; the next login re-opens it authenticated.
					if (this.$ws) {
						this.$ws.logout();
					}
					VueCookies.remove('access_token');
					localStorage.removeItem('sign-in');
					this.$router.replace({ name: 'Login' });
				} catch (e) {
					this.$router.replace({ name: 'Login' });
				}
			}
		},
		created() {
			// Registering window resize event listener to fix affix elements size
			// error while resizing.
			window.addEventListener("resize", this.resizeEventHandler);
		},
		destroyed() {
			// Removing window resize event listener.
			window.removeEventListener("resize", this.resizeEventHandler);
		},
	})

</script>
